import React, { useState, useEffect } from "react";
import { Grid, SelectChangeEvent, TextField } from "@mui/material";
import { DatePicker } from "@mui/x-date-pickers";
import { Moment } from "moment";

import Select from "../Select";
import { DATE_FORMAT } from "../../../constants";

interface IProps {
  startDate: Moment | null;
  endDate: Moment | null;
  onChange: (date: Moment | null, inputName: string) => void;
  onClear: () => void;
  label: string;
}

export const DATE_RANGE_OPTIONS = [
  {
    name: "after",
    text: "After",
  },
  {
    name: "before",
    text: "Before",
  },
  {
    name: "between",
    text: "Between",
  },
];

type RangeType = (typeof DATE_RANGE_OPTIONS)[number]["name"];

const DateRangePicker: React.FC<IProps> = ({ startDate, endDate, onChange, onClear, label }) => {
  const [selectedRange, setSelectedRange] = useState<RangeType>("after");

  const handleRangeChange = (event: SelectChangeEvent<string>) => {
    const newRange = event.target.value as RangeType;
    setSelectedRange(newRange);
  };

  useEffect(() => {
    onClear();
  }, [selectedRange]);

  const isSelectAfter = ["after", "between"].includes(selectedRange);
  const isSelectBefore = ["before", "between"].includes(selectedRange);

  return (
    <>
      <Grid item xs={2}>
        <Select
          fullWidth
          inputLabel={label}
          label={label}
          value={selectedRange}
          onChange={handleRangeChange}
          options={DATE_RANGE_OPTIONS}
        />
      </Grid>
      {isSelectAfter && (
        <Grid item xs={2}>
          <DatePicker<Moment>
            inputFormat={DATE_FORMAT}
            label={label + " after"}
            value={startDate}
            onChange={(date) => onChange(date, "after")}
            renderInput={(params) => <TextField name="after" {...params} />}
          />
        </Grid>
      )}
      {isSelectBefore && (
        <Grid item xs={2}>
          <DatePicker<Moment>
            inputFormat={DATE_FORMAT}
            label={label + " before"}
            value={endDate}
            onChange={(date) => onChange(date, "before")}
            minDate={selectedRange === "between" && startDate ? startDate : undefined}
            renderInput={(params) => <TextField name="before" {...params} />}
          />
        </Grid>
      )}
    </>
  );
};

export default DateRangePicker;
